import { ConsultaIpocPesquisaComponent } from './consulta-ipoc-pesquisa.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';

const routes: Routes = [
  {
    path: 'consulta-ipoc',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },

    children: [
      {
        path: 'pesquisa',
        component: ConsultaIpocPesquisaComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class ConsultaIpocRoutingModule { }
